import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { AREA_CODE } from '@core/data-access';
import { DialCodeOptions } from '@portal/data-access';

@Injectable()
export class MobileAreaCodePresetProvider implements FormlyFieldConfigPresetProvider {
  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'select',
      defaultValue: AREA_CODE.DEFAULT,
      props: {
        placeholder: 'Please Select',
        options: DialCodeOptions,
        highlightSelected: false,
        displayWith: (value: string) => `+${value}`,
      },
    };
  }
}

export function registerMobileAreaCodePreset(): ConfigOption {
  return { presets: [{ name: 'mobileAreaCode', config: new MobileAreaCodePresetProvider() }] };
}
